/**
 * Maps claims manager email addresses to display names
 * @param {string} email - The email address to map
 * @returns {string} - The display name, or the original email if no mapping exists
 */
export const getClaimsManagerDisplayName = (email) => {
  if (!email) return email;

  const mapping = {
    'julieb@vigilant.org': 'Julie',
    'daniellew@vigilant.org': 'Danielle',
    'sandib@vigilant.org': 'Baby Claim',
  };

  return mapping[email] || email;
};
